import type { SortOption } from "../components/SortPopover/SortPopover";
import type {
  ResourceTileProps,
  TaggedResourceTiles,
} from "./contentful-helpers";

export const sortResourceTiles = (
  tiles: TaggedResourceTiles[],
  option: SortOption,
) => {
  switch (option) {
    case "a-z":
      return tiles.map((group) => {
        return {
          ...group,
          data: group.data.toSorted((a, b) => alphabeticalSort(a, b, false)),
        };
      });

    case "z-a":
      return tiles.map((group) => {
        return {
          ...group,
          data: group.data.toSorted((a, b) => alphabeticalSort(a, b, true)),
        };
      });

    case "featured":
      return tiles.map((group) => {
        return {
          ...group,
          data: group.data.toSorted(prioritySort),
        };
      });
  }
};

const alphabeticalSort = (
  a: ResourceTileProps,
  b: ResourceTileProps,
  reverse: boolean,
) => {
  return reverse
    ? b.title.localeCompare(a.title)
    : a.title.localeCompare(b.title);
};

const prioritySort = (a: ResourceTileProps, b: ResourceTileProps) => {
  return (a.data.sorting?.priority ?? 0) - (b.data.sorting?.priority ?? 0);
};
